export default __webpack_public_path__ + "static/Megazeichen_V-87efb96ba5ee6d4fe3de414431c1e3d8.jpg";